import { FeatureUnboxingEmbedderMessages } from 'feature-unboxing-embedder';
export function sendCloseIframeMessage() {
  window.parent.postMessage({
    action: FeatureUnboxingEmbedderMessages.CloseIframe
  }, '*');
}
export function sendRedirectToMessage(url) {
  window.parent.postMessage({
    action: FeatureUnboxingEmbedderMessages.RedirectTo,
    value: url
  }, '*');
}